export const calculateInflationAdjustedRateFromNominal = (nominalRate: number, inflationRate: number): number => {
    return ((1 + nominalRate / 100) / (1 + inflationRate / 100) - 1) * 100;
};

export const calculateNominalFromInflationAdjustedRate = (inflationRate: number, inflationAdjustRate: number): number => {
    return ((1 + inflationRate / 100) * (1 + inflationAdjustRate / 100) - 1) * 100;
};

export const calculateInflationAdjustedRateFromNominalFormatted = (
    nominalRate: number,
    inflationRate: number,
    addPercentageSymbol = false
): string => {
    const inflationAdjustedRate = calculateInflationAdjustedRateFromNominal(nominalRate, inflationRate);
    const inflationAdjustedRate2Dp = inflationAdjustedRate.toFixed(2);
    return addPercentageSymbol ? `${inflationAdjustedRate2Dp} %` : inflationAdjustedRate2Dp;
};

export const calculateNominalFromInflationAdjustedRateFormatted = (
    inflationRate: number,
    inflationAdjustRate: number,
    addPercentageSymbol: boolean = false
): string => {
    const nominalRate = calculateNominalFromInflationAdjustedRate(inflationRate, inflationAdjustRate);
    const nominalAdjustRate2Dp = nominalRate.toFixed(2);
    return addPercentageSymbol ? `${nominalAdjustRate2Dp} %` : nominalAdjustRate2Dp;
}
